export const TOBL_AI_PLUS_MONTHLY_PRICE = "price_1O3mGOCx5SCUNLNEB9UOTW1D";
export const TOBL_AI_PLUS_YEARLY_PRICE = "price_1O4qBOCx5SCUNLNEMv1DZUvg";
export const TOBL_AI_COUPON_EARLY_ADOPTER = "promo_1O4WOmCx5SCUNLNEnmwqhdui";
